import type { AnalyticsFlightsAndAppSettings } from 'owa-analytics-types';
import { getApplicationSettings } from 'owa-application-settings';
import { isGulpOrBranching } from 'owa-config';
import { isDataWorkerPlatformEnabled } from 'owa-data-worker-check';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

export function initializeAnalyticsFlightsAndAppSettings(): AnalyticsFlightsAndAppSettings {
    const isDevEnvironment = isGulpOrBranching();
    const analyticsApplicationSettings = getApplicationSettings('Analytics');

    const settings: AnalyticsFlightsAndAppSettings = {
        // ECS Settings
        disabledDatapoints: analyticsApplicationSettings.disabledDatapoints || [],
        throttledDatapoints: analyticsApplicationSettings.throttledDatapoints || [],
        disableIsCoreDatapoints: analyticsApplicationSettings.disableIsCoreDatapoints || [],
        enableHighCountEventThrottle: analyticsApplicationSettings.enableHighCountEventThrottle,
        highCountEventThrottleWindow: analyticsApplicationSettings.highCountEventThrottleWindow,
        highCountEventThrottleThreshold:
            analyticsApplicationSettings.highCountEventThrottleThreshold,
        capturePerfProfiles: analyticsApplicationSettings.capturePerfProfiles || [],
        maxPerfProfilesPerSession: analyticsApplicationSettings.maxPerfProfilesPerSession,

        // Feature Flights
        shouldCaptureAssets: isGlobalFeatureEnabled('an-log-assets'),
        skipFlightControls:
            isGlobalFeatureEnabled('ring-dogfood') || isGlobalFeatureEnabled('an-no-sample-ppe'),
        isFullVerboseLoggingEnabled: isGlobalFeatureEnabled('an-full-logging'),
        enablePrivacyGuard: isGlobalFeatureEnabled('fwk-oneDs-privacyGuard'),
        enableSchemaEnforcement: isGlobalFeatureEnabled('fwk-schema-enforcement'),
        turnOffCustomData: isGlobalFeatureEnabled('fwk-turnOffCustomData'),
        devToolsEnabled: isDevEnvironment || isGlobalFeatureEnabled('fwk-devTools'),
        trackEventFrequency: isGlobalFeatureEnabled('fwk-an-trackEventFrquency'),
        isDataWorkerEnabled: isDataWorkerPlatformEnabled(),
        enableOfflineCaching: isGlobalFeatureEnabled('fwk-offline-boot'),
        isDiagDatapointTracingPanelEnabled: isGlobalFeatureEnabled(
            'fwk-diag-datapoint-tracing-panel'
        ),
    };

    return settings;
}
